// MAGIC_DESPROCKET_START
//   ************THIS IS NOT THE RIGHT WAY TO STRUCTURE MODERN JS FILES************
//
//   For details and info on using this file see the wiki:
//     https://github.com/academia-edu/wiki/blob/master/development/formerly-sprockets-files.md
//
//   STATUS: auto generated
//   LOADERS:
//   ROOT: app/assets/webpack_entry/core_webpack.wjs.jsx
// MAGIC_DESPROCKET_END
(function(){
  Aedu.UserAffiliation = createReactClass({
    propTypes: {
      user: PropTypes.object.isRequired,
      displayClass: PropTypes.string,
      textClass: PropTypes.string,
      numberOfItems: PropTypes.number
    },

    getDefaultProps: function(){
      return {
        displayClass: "u-displayBlock",
        textClass: "u-fs12",
        numberOfItems: 2,
      }
    },

    researchInterestListCard: function(el){
      if (el && this.props.user.interests.length > 1){
        new Aedu.ResearchInterestListCard({
          el: el,
          work: this.props.user,
        });
      }
    },

    render: function() {
      var user = this.props.user;
      var userLocation;
      if (user.user_location) {
        userLocation = _.compact([user.user_location.city, user.user_location.country]).join(", ");
      }
      var university;
      var occupation;
      if (user.department){
        university = user.department.university.name;
        occupation = _.compact([user.position, user.department.name]).join(", ");
      } else if (user.user_occupation){
        occupation = user.user_occupation.name;
      }
      var interests;
      if (user.interests.length){
        interests = user.interests.length > 1 ? user.interests[0].name + " + " + (user.interests.length-1) : user.interests[0].name;
      }
      var componentClass = this.props.textClass + " " + this.props.displayClass;
      var totalViews = user.all_time_view_counts && (user.all_time_view_counts.documents_count + user.all_time_view_counts.non_documents_count);

      return(
        <div className={this.props.displayClass}>
          {_.compact([
            university && (
              <div key="uni" className={componentClass}>
                <i className="fa fa-university fa-fw"/>&nbsp;&nbsp;{university}&nbsp;&nbsp;&nbsp;&nbsp;
              </div >
            ),
            occupation && (
              <div key="occupation" className={componentClass}>
                <i className="fa fa-briefcase fa-fw"></i>&nbsp;&nbsp;{occupation}&nbsp;&nbsp;&nbsp;&nbsp;
              </div >
            ),
            userLocation && (
              <div key="location" className={componentClass}>
                <i className="fa fa-map-marker fa-fw"></i>&nbsp;&nbsp;{userLocation}&nbsp;&nbsp;&nbsp;&nbsp;
              </div >
            ),
            user.percentile && (
              <div key="percentile" className={componentClass}>
                <i className="fa fa-trophy fa-fw"/>&nbsp;&nbsp;
                <span>{$h.capitalize(user.percentile)}</span>
                &nbsp;&nbsp;&nbsp;&nbsp;
              </div>
            ),
            interests && (
              <div key="interests" className={componentClass}>
                <i className="fa fa-tag fa-fw"/>
                <span ref={this.researchInterestListCard}>
                  &nbsp;&nbsp;{interests}&nbsp;&nbsp;&nbsp;&nbsp;
                </span>
              </div >
            ),
            totalViews && totalViews > 1 && (
              <div key="views" className={componentClass}>
                <span className="u-fw700">{$h.commaizeInt(totalViews)}</span> Total Views
                &nbsp;&nbsp;&nbsp;&nbsp;
              </div>
            ),
            user.followers_count && (
              <div key="followers" className={componentClass}>
                <span className="u-fw700">{$h.commaizeInt(user.followers_count)}</span> {$h.pluralize(user.followers_count, "Follower")}
                &nbsp;&nbsp;&nbsp;&nbsp;
              </div>
            ),
          ]).slice(0,this.props.numberOfItems)}
        </div>
      );
    },

  });
})();
